import React from "react";

/**
 * Eyebrow + heading + optional lede, in the two tones the site uses:
 * "light" for cream/white sections, "dark" for the purple bands.
 */
function SectionHeading({ eyebrow, title, lede, tone = "light", align = "left" }) {
  const dark = tone === "dark";

  return (
    <div className={align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-2xl"}>
      {eyebrow && (
        <span className={`mw-eyebrow ${dark ? "text-[#D8B4FE]" : "text-[#6A0DAD]"}`}>
          {eyebrow}
        </span>
      )}
      <h2 className={`mw-h2 mt-5 ${dark ? "text-white" : "text-[#1E1B16]"}`}>{title}</h2>
      {lede && (
        <p className={`mw-lede mt-5 ${dark ? "text-[#DCC9F2]" : "text-[#4D4B46]"}`}>{lede}</p>
      )}
    </div>
  );
}

export default SectionHeading;
